import { Component, Inject,Input , Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import _ from 'lodash';
import { BroadCastService } from '../../services/broadcast.service';
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PeformanceContext } from '../../interfaces/mysynch.interfaces';

@Component({
  standalone: false,
  selector: 'user-profile',
  templateUrl: '../app/pages/user-profile/user-profile.view.html',
  styleUrls:['../app/pages/user-profile/user-profile.style.css']
})
export class UserProfile {
    @ViewChild('userProfileForm') userProfileForm: NgForm;
    
    private performanceContext: PeformanceContext | null = null;
    private newUser:any = null;
    private loading:boolean = true;
    private saving:boolean = false;
    private generalError:string = null;

    private emailInUse:boolean = false;
    private previousEmail:string = null;

    private inputs:any = {};
   
    private territory:string = "";

     _:any;
    codeFile:any = [];
    personTypes:any = [];
    countries:any = [];
    
	statesAndProvinces:any = [];
	states:any = [];

    initialPersonTypeOption:any = {personTypeId: 0, name: "Select role"};
    selectedPersonTypeOption:any = {personTypeId: 0, name: "Select role"};
    personTypeConfig:Object = {
        controlId:"personType",
        labelProperty:"name",
        valueProperty:"personTypeId",
        orderByField:["name"],
        orderByDirection: ["asc"],
        placeholder: "Select role",
        virtualScroll: true
     }
     onPersonTypeChange(selectedPersonType) {
        this.selectedPersonTypeOption = selectedPersonType;
        _.set(this.inputs, 'personTypeId', this._.get(selectedPersonType,"personTypeId"));
     }
     
     emptyCountryOption:any = {id:0,code: "", codeValue: "Select country"};
     initialCountryOption:any = this.emptyCountryOption;
     selectedCountryOption:any = this.emptyCountryOption;
     countryConfig:Object = {
         controlId:"country",
         labelProperty:"codeValue",
         valueProperty:"codeValue",
         orderByField:["dropDownSeq"],
         orderByDirection: ["asc"],
         placeholder: "Select country",
         virtualScroll: true,
         defaultSelectedItem: this.emptyCountryOption
      }
      onCountryChange(selectedCountry) {
        this.selectedCountryOption = selectedCountry;
        _.set(this.inputs,"country", _.get(selectedCountry,"codeValue"));
         // reset the state dropdown to the states\provinces for the selected country and clear the selected state
        this.setStateList(this._.get(selectedCountry,"codeValue"));
       
        this.broadCastSrv.clearControlMsg("state");
        this.selectedStateOption =  this.emptyStateOption;
        _.set(this.inputs,"state", null);
      }
     emptyStateOption:any = {id:0,code: "", codeValue: "Select state"};
     initialStateOption:any = this.emptyStateOption;
     selectedStateOption:any = this.emptyStateOption;
     stateConfig:Object = {
         controlId:"state",
         labelProperty:"codeValue",
         valueProperty:"code",
         orderByField:["dropDownSeq"],
         orderByDirection: ["asc"],
         placeholder: "Select state",
         virtualScroll: true,
         defaultSelectedItem: this.emptyStateOption
      }
      onStateChange(selectedState) {
        this.selectedStateOption =  selectedState;
        _.set(this.inputs,"state", _.get( selectedState,"code"));
      }
    
    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject('ApiFactory') private api:any,
                @Inject('ViewAuthorizationFactory') private viewAuth:any,
                @Inject('CookieFactory') private cookies:any,
                @Inject(MySynchConstantService) private mysynchConstantsSvc:any,
                @Inject(BroadCastService) private broadCastSrv:BroadCastService,
                @Inject(PerformanceMetricsService) private perfMetricsSvc: PerformanceMetricsService,
                @Inject(PerformanceContextService) private perfContextSvc: PerformanceContextService
            ){
                 
             this._ = _;
      
      }

    
    //TODO: use a package for this or look for the function in common or something
    private pascalCase(val) {
        if (typeof val === 'string') {
            return val.substring(0, 1).toUpperCase() + val.substring(1);
        }

        return this._.zipObject(this._.map(_.keys(val), (key) => {
            return this.pascalCase(key);
        }), this._.values(val));
    }
    private skipLoginCheck(personId, email, done) {
        done(null, {available: true});
    }

    termsAndPrivacyInNewWindow() {
        window.open('https://parnell.com/mysynch-terms-conditions/', '_blank');
        /// TODO: Set EULA Accepted On here, if NULL (TBD-Confirm w/ Kelly / Angela)
    };
    // sets country select with the empty option.
    setEmptyCountryOption(){
        this.initialCountryOption = this.emptyCountryOption;
    }
    // sets state select with the empty option.
    setEmptyStateOption(){
        this.initialCountryOption = this.emptyStateOption;
    }
    // sets the options available in the states dropdown
    setStateList(country){      
        var states = _.get(_.find(this.statesAndProvinces,{country: country}),'states',[]) ;
        this.states = states;     
    }
 
    // function that loads the select options for the dropdowns
    loadSelectOptions(){
        this.loadCountryList();
        this.loadStateList();
    }
    // function that loads the $s.countries with available countries
    // and then sets the country dropdown options to the countries
    loadCountryList(){
        var countries = _.map(_.filter(this.codeFile,{codeType: "COUNTRY"}),(countryItem)=>{
                                return _.pick(countryItem,["id","code","codeValue","dropDownSeq"]);
                             });
        this.countries = countries;


    }
    // function that loads $s.satesAndProvinces with available countries and their states(or Provinces)
	// and then sets the state dropdown options to the states\provinces for the farm's country
    loadStateList(){ 
        var allStatesAndProvinces = this.MSF.getCodeFileSubsetWithParsedDetailsJson(
                                                _.filter(this.codeFile,(codeFileItem)=>{
                                                    var codeType = _.get(codeFileItem,'codeType');
                                                    return _.isEqual(codeType,'STATE') || _.isEqual(codeType,'PROVINCE');
                                                })
                                    );

        _.forEach(this.countries,(country)=>{
            var countryCode = _.get(country,'code');
            var countryCodeValue = _.get(country,'codeValue');

            var stateList = {
                country : countryCodeValue,
                states: _.map(_.filter(allStatesAndProvinces,(stateAndProvinceItem)=>{
                                return _.isEqual(_.get(stateAndProvinceItem,'detailsJson.country'),countryCode);
                              }),
                              (stateItem)=>{
                                    return _.pick(stateItem,["id","code","codeValue","dropDownSeq"]);
                              }
                            )
            }

            this.statesAndProvinces.push(stateList);

        });
        
        var userCountry = _.get(this.inputs,'country');
        if(!this.MSF.hasValue(userCountry)){
            userCountry = this.mysynchConstantsSvc.defaultUserCountry;
        }
        this.setStateList(userCountry);

    }


    loadUserProfile() {
        
            this.loading = true;
        if (this.viewAuth.checkUser()) {
                return new Promise<void>((resolve, reject) => {    
                    this.perfMetricsSvc.startTiming("Page:UserProfile:Build");
                    this.inputs = this.MSF.lowerCaseObjectKeys(this._.pick(this.cookies.user, [
                        'FirstName',
                        'LastName',
                        'Email',
                        'Phone',
                        'PersonTypeId',
                        'Address1',
                        'Address2',
                        'City',
                        'State',
                        'Country',
                        'PostCode'
                    ]));
                    this.loadSelectOptions();
                    this.buildMappedFieldsForLoad();
                    
                
                    

                    this.loading = false;
                    this.perfMetricsSvc.endTiming("page","Page:UserProfile:Build", this.performanceContext);
                    resolve();
                });
            } else {
                this.MSF.loadPage('Login');
            }
        
    }

    duplicateUsername() {
        return this.emailInUse && (this.inputs.email || '').toLowerCase() == (this.previousEmail || '').toLowerCase();
    };

    loginAvailable(personId, email, done) {
        this.api.loginAvailable(personId, email, done);
    }

    save() {
        this.emailInUse = false;
        this.previousEmail = this.inputs.email;
    
        var fieldsToUpdate = ['firstName', 'lastName', 'email', 'phone', 'personTypeId','address1', 'address2', 'city', 'state','country', 'postCode']

        this.buildMappedFieldsForSave();

        var currentForm = this.userProfileForm;
 
        var checkLoginAvailable = this.loginAvailable.bind(this);

        if (currentForm && !currentForm.valid) {
            this.MSF.touchForm(currentForm);

            return;
        }

        
        checkLoginAvailable(this.cookies.user.PersonId, this.inputs.email, (err, result) => {
            if (err) {
                console.log('Error checking loginId availability ' + err);
                this.saving = false;

                return this.MSF.notify.danger('Unable to save changes');
            }

            if (!result.available) {
                console.log('requested loginId is unavailable');
                this.previousEmail = this.inputs.email;
                this.emailInUse = true;
                this.saving = false;

                return;
            }

            this.api.updateUser(this._.extend({}, this.MSF.lowerCaseObjectKeys(this.cookies.user), this.inputs), (err, person) => {
                if (err) {
                    console.log('Error updating user ' + err);

                    this.saving = false;

                    return this.MSF.notify.danger('Unable to save changes');
                }

                this.cookies.user = this._.extend(this.cookies.user, this.pascalCase(this._.pick(this.inputs, fieldsToUpdate)));
                this.cookies.save();

                this.saving = false;
                this.MSF.notify.success('Profile changes saved.');
            });
        });
    };

    buildMappedFieldsForLoad(){
            
        // building Territory from lastName field. 
        var lastName = this._.get(this.inputs,'lastName',"");
        var territoryStart = this._.indexOf(lastName,"(");
        var territoryEnd = this._.indexOf(lastName,")");

        if(territoryStart > -1 && territoryEnd > -1){
            this.territory  = lastName.substr(territoryStart + 1,territoryEnd - (territoryStart+1)); 
            
            var cleanedLastName = lastName.substr(0,territoryStart - 1);
            this._.set(this.inputs,'lastName',cleanedLastName);
        }
        
        this.initialPersonTypeOption = this._.find(this.personTypes, {personTypeId: this._.get(this.inputs,'personTypeId')});
        this.selectedPersonTypeOption = this.initialPersonTypeOption;

        this.initialStateOption = this._.find(this.states, {code: this._.get(this.inputs,'state')});
        this.selectedStateOption = this.initialStateOption;
        
        var userCountryObj = this._.find(this.countries, {codeValue: this.mysynchConstantsSvc.defaultUserCountry});
        var userCountry = this._.get(this.inputs,'country');
        if(this.MSF.hasValue(userCountry)){
            userCountryObj = this._.find(this.countries, {codeValue: userCountry});  
        }else{
            _.set(this.inputs,"country", _.get(userCountryObj,"codeValue"));
        }
        this.initialCountryOption = userCountryObj
        this.selectedCountryOption = userCountryObj;
    };
    
    buildMappedFieldsForSave(){
            
        
        // building lastName field with territory 

        var lastName = this._.get(this.inputs,'lastName',"");
    
        if(!this._.isNull(this.territory) && !this._.isEqual(this.territory,"")){
            
            var lastNameWithTerritory = lastName+" ("+this.territory+")";
            
            this._.set(this.inputs,'lastName',lastNameWithTerritory);
        }

    };


    savePassword() {
        if (this._.isEmpty(this.inputs.password) || this._.isEmpty(this.inputs.confirmPassword)) {
            return this.MSF.notify.danger('Password and Confirm Password are required fields');
        }

        if (this.inputs.password !== this.inputs.confirmPassword) {
            return this.MSF.notify.danger('Password and Confirm Password must match');
        }

        this.saving = true;
        this.api.updatePassword(this.cookies.user.PersonId, this.inputs.password, (err, person) => {
            this.saving = false;
            this.inputs.password = '';
            this.inputs.confirmPassword = '';

            if (err) {
                console.log('Error updating user ' + err);

                return this.MSF.notify.danger('Unable to save changes');
            }

            this.MSF.notify.success('Password changes saved.');
        });
    };

    cancel() {
        this.generalError = null;
        this.loadUserProfile();
    };

    ngOnInit(){
        this.MSF.ready(()=>{
            this.performanceContext = this.perfContextSvc.createPerformanceContext();
            this.perfMetricsSvc.startTiming("Page:UserProfile:Render");
            this.codeFile = this._.get(this.MSF,"lists.codeFile",[]);
            this.personTypes = this._.get(this.MSF,'lists.personType',[]);

            this.loadUserProfile().then(() => {
                this.perfMetricsSvc.markPageReady("Page:UserProfile:Render", this.performanceContext);
            });
        });
    };

}